import React, { useEffect, useState } from "react";

import { useQuery } from "@tanstack/react-query";

import MediaLibraryItemDragLayer from "./MediaLibraryItemDragLayer";
import MediaLibraryItemList from "./MediaLibraryItemList";
import MediaLibraryOrder from "./MediaLibraryOrder";
import MediaLibrarySearch from "./MediaLibrarySearch";
import FastAPI from "../../../api/FastAPI";
import { MEDIA_LIBRARY_LIST_WIDTH } from "../../../constants/fast";
import { AD_BREAK, TIMESLOT } from "../../../constants/media";

import type { JSX } from "react";

import type { MediaItem } from "./MediaLibraryItemList";
import type { Order } from "./MediaLibraryOrder";

interface MediaLibraryProps {
  channelId: string;
}

function TemplateAssetLibrary({ channelId }: MediaLibraryProps): JSX.Element {
  const [mediasList, setMediasList] = useState<MediaItem[]>([]);
  const [search, setSearch] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>("");
  const [order, setOrder] = useState<Order>({
    direction: "up",
    field: "label",
  });

  const getTemplatesAssetListQuery = FastAPI.generateQuery({
    fn: FastAPI.getTemplatesAssetList,
    params: [channelId],
  });

  const { data: templatesAssetList, isLoading } = useQuery(
    getTemplatesAssetListQuery,
  );

  useEffect(() => {
    const formatedTemplatesAssetList: MediaItem[] =
      templatesAssetList?.data.reduce((acc: MediaItem[], media) => {
        if (media.object === "adbreak") {
          acc.push({
            uuid: media.uuid,
            updated_at: media.updated_at,
            type: AD_BREAK,
            source_duration: media.duration,
            label: media.name,
            format: AD_BREAK,
          });
        }

        if (media.object === "timeslot") {
          acc.push({
            uuid: media.uuid,
            updated_at: media.updated_at,
            type: TIMESLOT,
            source_duration: media.duration_ms,
            label: media.name,
            color: media.color,
          });
        }

        return acc;
      }, []) ?? [];

    setMediasList(formatedTemplatesAssetList);
  }, [templatesAssetList]);

  const filteredMediasList = mediasList
    .filter((media) => media.label.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      if (order.direction === "up") {
        return (a[order.field] as string) > (b[order.field] as string) ? 1 : -1;
      }
      return (a[order.field] as string) < (b[order.field] as string) ? 1 : -1;
    });

  return (
    <React.Fragment>
      <MediaLibraryItemDragLayer />
      <div
        className="flex h-full flex-col"
        style={{ width: MEDIA_LIBRARY_LIST_WIDTH }}
      >
        <div className="flex gap-[0.3125rem]">
          <MediaLibrarySearch
            inputValue={inputValue}
            setInputValue={setInputValue}
            setSearch={setSearch}
          />
          <MediaLibraryOrder order={order} setOrder={setOrder} />
        </div>
        <MediaLibraryItemList
          isCustomDragLayer
          isLoading={isLoading}
          medias={filteredMediasList}
        />
      </div>
    </React.Fragment>
  );
}

export default TemplateAssetLibrary;
